/** The Wall's tabs (WF-WAL-01). Favorites stays as a tab, saying where they went (decision 201). */
export type WallTab = 'wall' | 'favorites' | 'saved'
export type WallSearch = { tab?: Exclude<WallTab, 'wall'>; post?: string }

/**
 * The route's search, as the router reads it. `?tab=spots` was the Spots tab before Favorites took it in
 * (decision 105), so it lands on Favorites, as every old Favorites link does (`&fav=` is let go).
 */
export function wallSearch(s: Record<string, unknown>): WallSearch {
  return {
    tab: s.tab === 'spots' ? 'favorites' : s.tab === 'saved' || s.tab === 'favorites' ? s.tab : undefined,
    // a post to scroll to: a mention's alert opens it (decision 134)
    post: typeof s.post === 'string' && /^[0-9a-f-]{36}$/i.test(s.post) ? s.post : undefined,
  }
}
